import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginForm from "./Pages/LoginForm/LoginForm";

import NotFoundPage from "./Pages/NotFoundPage";
import AuthProvider from "react-auth-kit";
import createStore from "react-auth-kit/createStore";
import HomePage from "./Pages/HomePage/HomePage";
import Layout from "./Layout/Layout";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";


import MapPage from "./Pages/MapPanel/MapPanel";

import FeedbackPage from "./Pages/Feedback/FeedbackPage";
import AdminPanel from "./Pages/AdminPanel/AdminPanel";

import AddDevice from "./Pages/HomePage/AddDevice";
import EditDevice from "./Pages/HomePage/EditDevice";
import DeviceDetails from "./Pages/HomePage/DeviceDetails";
import MenuItemsManager from "./Pages/HomePage/MenuItemsManager";
import DataTables from "./Pages/DataTables/DataTables";
import { RefreshProvider } from "./Components/RefreshContext";
import CustomRequireAuth from "./Pages/CustomRequireAuth";
import RepairPanel from "./Pages/RepairPanel/RepairPanel";
import AddShipment from './Pages/Shipments/AddShipment';


import ShipmentPanel from './Pages/Shipments/ShipmentPanel';
import AddDetails from "./Pages/Shipments/AddDetails";
import InstalationPage from "./Pages/InstalationPage/InstalationPage";
import InstalationDetailPage from "./Pages/InstalationPage/InstalationDetailPage";
import RoleBasedRoute from "./Pages/RoleBasedRoute";
import posthog from 'posthog-js'
import BulkShipmentCreation from './Pages/Shipments/BulkDeviceProcess';
import BulkEditDevices from './Pages/HomePage/BulkEditDevices';
import InventoryPanel from "./Pages/InventoryPanel/InventoryPanel";
import InventoryHistory from "./Pages/InventoryPanel/InventoryHistory";
import { NotificationProvider } from './Components/NotificationBell/NotificationContext';
import NotificationsPage from './Pages/NotificationsPage/NotificationsPage';

import CreateNotification from './Pages/NotificationsPage/CreateNotification';
import Forum from "./Pages/ComunityForum/Forum";
import Dashboard from "./Pages/Dashboard/Dashboard";

import LocationPage from "./Pages/LocationPage/LocationPage";


function App() {
  useEffect(() => {
    // Test czy PostHog działa
    posthog.capture('app_loaded', {
      timestamp: new Date().toISOString(),
      environment: import.meta.env.MODE
    });

    // Dodaj console.log dla weryfikacji
    console.log('PostHog event sent: app_loaded');
  }, []);

  const router = createBrowserRouter([


    {
      path: "/login",
      element: <LoginForm />,
      errorElement: <NotFoundPage />,
    },
    {
      element: (
        <CustomRequireAuth>
          <Layout />
        </CustomRequireAuth>
      ),
      children: [
        {
          path: "/",
          element: <RoleBasedRoute
            element={<HomePage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
            redirectToLoginOnDisallowed={true}
          />,
        },
        {
          path: "/dashboard",
          element: <RoleBasedRoute
            element={<Dashboard />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/installation",
          element: <RoleBasedRoute
            element={<InstalationPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+', 'instalator']}
          />,
        },
        {
          path: "/installation/:boxNumber",
          element: <RoleBasedRoute
            element={<InstalationDetailPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+', 'instalator']}
          />,
        },
        {
          path: "/profile",
          element: <RoleBasedRoute
            element={<ProfilePage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+', 'instalator']}
          />,
        },


        {
          path: "/map/:view",
          element: <RoleBasedRoute
            element={<MapPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/map/:view/:boxId",
          element: <RoleBasedRoute
            element={<MapPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/feedback",
          element: <RoleBasedRoute
            element={<FeedbackPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },

        {
          path: "/admin",
          element: <RoleBasedRoute
            element={<AdminPanel />}
            allowedRoles={['admin', 'serwis+']}
          />,
        },

        {
          path: "/data",
          element: <RoleBasedRoute
            element={<DataTables />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },

        {
          path: "/add-device",
          element: <RoleBasedRoute
            element={<AddDevice />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/edit-device/:deviceNumber",
          element: <RoleBasedRoute
            element={<EditDevice />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/device/:deviceNumber",
          element: <RoleBasedRoute
            element={<DeviceDetails />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/menu-items-manager",
          element: <RoleBasedRoute
            element={<MenuItemsManager />}
            allowedRoles={['admin']}
          />,
        },
        {
          path: "/repairs",
          element: <RoleBasedRoute
            element={<RepairPanel />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/shipments",
          element: <RoleBasedRoute
            element={<ShipmentPanel />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/shipments/add",
          element: <RoleBasedRoute
            element={<AddShipment />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/shipments/add-details/:groupId",
          element: <RoleBasedRoute
            element={<AddDetails />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/shipments/bulk-process",
          element: <RoleBasedRoute
            element={<BulkShipmentCreation />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/bulk-edit",
          element: <RoleBasedRoute
            element={<BulkEditDevices />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/inventory",
          element: <RoleBasedRoute
            element={<InventoryPanel />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/inventory/history",
          element: <RoleBasedRoute
            element={<InventoryHistory />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/notifications",
          element: <RoleBasedRoute
            element={<NotificationsPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },
        {
          path: "/notifications/add",
          element: <RoleBasedRoute
            element={<CreateNotification />}
            allowedRoles={['admin']}
          />,
        },
        {
          path: "/forum",
          element: <RoleBasedRoute
            element={<Forum />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+']}
          />,
        },

        {
          path: "/location",
          element: <RoleBasedRoute
            element={<LocationPage />}
            allowedRoles={['admin', 'user', 'serwis', 'serwis+', 'instalator']}
          />,
        },
      ],
    }
  ]);

  const store = createStore({
    authType: "cookie",
    authName: "_auth",
    cookieDomain: window.location.hostname,
    cookieSecure: false,
  });

  return (
    <NotificationProvider>
      <AuthProvider store={store}>
        <RefreshProvider>
          <RouterProvider router={router} />
        </RefreshProvider>
      </AuthProvider>
    </NotificationProvider>
  );
}

export default App;
